import React, { useMemo } from "react";
import { Box, chakra, keyframes } from "@chakra-ui/react";
import stripIndent from "strip-indent";
import { ClipboardButton } from "./clipboard-button";
import { Text } from "./text";
// See https://css-tricks.com/click-once-select-all-click-again-select-normally/
const selectAnimation = keyframes `
    to { user-select: text; }
`;
export function CodeSnippet({ code, label, ...props }) {
    const formattedCode = useMemo(() => {
        return stripIndent(code).trim();
    }, [code]);
    return (React.createElement(Box, { bg: "base.lightBackground", border: "1px", borderColor: "base.border", borderRadius: "md", color: "text.primary", position: "relative", ...props },
        label ? (React.createElement(Box, { bg: "gray.200", alignItems: "center", borderTopRadius: "base", borderBottom: "1px", borderColor: "base.border", display: "flex", justifyContent: "space-between", pl: 3, pr: 1, py: 1 },
            React.createElement(Text, { isTruncated: true }, label),
            React.createElement(Box, { sx: {
                    button: {
                        _hover: {
                            bg: "gray.300",
                        },
                    },
                } },
                React.createElement(ClipboardButton, { text: formattedCode })))) : (React.createElement(Box, { position: "absolute", top: 1, right: 1, sx: {
                button: {
                    bg: "gray.100",
                    _hover: {
                        bg: "gray.200",
                    },
                },
            } },
            React.createElement(ClipboardButton, { text: formattedCode }))),
        React.createElement(chakra.pre, { overflow: "auto", overscrollBehaviorX: "contain", px: 3, py: 2, color: "text.primary" },
            React.createElement(Box, { as: "code", fontSize: "md", fontFamily: "mono", tabIndex: 0, userSelect: "all", _focus: {
                    animation: `${selectAnimation} 100ms step-end forwards`,
                } }, formattedCode))));
}
